import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import { api } from "../lib/api";

function Badge({ ok }) {
  return (
    <span className={"text-xs rounded px-2 py-0.5 " + (ok ? "bg-emerald-500/15 text-emerald-400" : "bg-neutral-700/40 text-neutral-400")}>
      {ok ? "conectado" : "não conectado"}
    </span>
  );
}

export default function Configuracoes() {
  const [data, setData] = useState(null);
  const [meta, setMeta] = useState({ access_token: "", ad_account_id: "", page_id: "" });
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const load = () => api.getSettings().then(setData).catch((e) => setErr(String(e.message)));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault(); setErr(""); setMsg("");
    try { const r = await api.connectMeta(meta); setMsg(`Meta conectado (${r.ad_account_preview})`); load(); }
    catch (e) { setErr(String(e.message)); }
  };
  const disconnect = async () => {
    try { await api.disconnectMeta(); setMsg("Meta desconectado"); load(); }
    catch (e) { setErr(String(e.message)); }
  };

  const inp = "w-full rounded-md bg-neutral-800 border border-neutral-700 px-3 py-2 text-sm mb-3";
  const card = "rounded-lg border border-neutral-800 bg-neutral-900/50 p-5";

  return (
    <Layout>
      <h1 className="text-2xl font-bold">Configurações</h1>
      {err && <div className="mt-4 rounded-md bg-red-600/15 text-red-400 px-4 py-2 text-sm">{err}</div>}
      {msg && <div className="mt-4 rounded-md bg-emerald-600/15 text-emerald-400 px-4 py-2 text-sm">{msg}</div>}

      {data && (
        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className={card}>
            <div className="text-sm font-medium mb-3">Conta</div>
            <div className="text-sm text-neutral-300">{data.account.name}</div>
            <div className="text-xs text-neutral-500">{data.account.email} · {data.account.role}</div>
          </div>

          <div className={card}>
            <div className="text-sm font-medium mb-3">Integrações</div>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between"><span>Foursquare (locais)</span><Badge ok={data.integrations.foursquare} /></div>
              <div className="flex justify-between"><span>Gemini (IA)</span><Badge ok={data.integrations.gemini} /></div>
              <div className="flex justify-between"><span>Meta Ads {data.integrations.meta_account_preview ? `(${data.integrations.meta_account_preview})` : ""}</span><Badge ok={data.integrations.meta_connected} /></div>
            </div>
          </div>

          <div className={`${card} md:col-span-2`}>
            <div className="text-sm font-medium mb-1">Conectar Meta Ads</div>
            <p className="text-xs text-neutral-500 mb-3">
              Necessário só para ativar campanhas reais. Sem isso, as campanhas
              ficam "prontas para ativação". O token é guardado por conta e nunca exibido.
            </p>
            <form onSubmit={save} className="max-w-md">
              <input className={inp} placeholder="Access Token" value={meta.access_token}
                onChange={(e) => setMeta({ ...meta, access_token: e.target.value })} required />
              <input className={inp} placeholder="Ad Account ID (act_...)" value={meta.ad_account_id}
                onChange={(e) => setMeta({ ...meta, ad_account_id: e.target.value })} required />
              <input className={inp} placeholder="Page ID (opcional)" value={meta.page_id}
                onChange={(e) => setMeta({ ...meta, page_id: e.target.value })} />
              <div className="flex gap-2">
                <button className="rounded-md bg-red-600 hover:bg-red-500 px-4 py-2 text-sm font-medium">Conectar</button>
                {data.integrations.meta_connected && (
                  <button type="button" onClick={disconnect} className="rounded-md border border-neutral-700 px-4 py-2 text-sm text-neutral-400 hover:text-neutral-100">Desconectar</button>
                )}
              </div>
            </form>
          </div>
        </div>
      )}
    </Layout>
  );
}
